import { FC } from "react";
import Container from "react-bootstrap/Container";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import { Navigate } from "react-router-dom";
import { FaRedo } from "react-icons/fa";
import { useRouteParams } from "app/route/route";
import { resendCompanyInviteRoute, companyInvitesRoute } from "app/route/Routes";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { useResendCompanyInviteMutation, useCompanyInviteQuery } from "app/api/graph/types";
import { companyInviteGraphId } from "app/api/graph/helpers";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { formatISODateTime } from "app/util/format";
import { ErrorScreen } from "app/component/screen/ErrorScreen";
import { LoadingScreen } from "app/component/screen/LoadingScreen";

export const ResendCompanyInviteScreen: FC = () => {
    const { companyId, inviteId } = useRouteParams(resendCompanyInviteRoute);
    const { data, loading, error } = useCompanyInviteQuery({
        variables: { inviteId: companyInviteGraphId(inviteId) },
    });
    const [resendInvite, { data: resendData, loading: resending, error: resendError }] = useResendCompanyInviteMutation(
        {
            variables: { input: { id: companyInviteGraphId(inviteId) } },
        },
    );
    const invite = data?.companyInvite;

    if (loading) {
        return <LoadingScreen />;
    }
    if (error) {
        return <ErrorScreen title="Error" message={error.message} />;
    }
    if (!invite) {
        return <ErrorScreen title="Error" message="Not found." />;
    }
    if (invite.accepted) {
        return <ErrorScreen title="Error" message="This invite has already been accepted." />;
    }
    if (resendData?.resendCompanyInvite) {
        return <Navigate to={companyInvitesRoute.build({ companyId })} />;
    }

    return (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={resendCompanyInviteRoute} />
                <h1>Resend invite</h1>
                {resendError ? <Alert variant="danger">{resendError.message}</Alert> : null}
                <p>Are you sure that you want to resend this invite?</p>
                <Table responsive="sm">
                    <tbody>
                        <tr>
                            <th>First name</th>
                            <td>{invite.firstName ?? "-"}</td>
                        </tr>
                        <tr>
                            <th>Last name</th>
                            <td>{invite.lastName ?? "-"}</td>
                        </tr>
                        <tr>
                            <th>Email</th>
                            <td>{invite.email ?? "-"}</td>
                        </tr>
                        <tr>
                            <th>Invited at</th>
                            <td>{formatISODateTime(invite.createdAt)}</td>
                        </tr>
                    </tbody>
                </Table>
                <Button variant="warning" disabled={resending} onClick={() => resendInvite()}>
                    <FaRedo /> Resend
                </Button>
            </Container>
        </NavigationScreen>
    );
};
